import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../app/appTypes";
import { postWithAuth } from "../../http";

export interface UrsRequestAiCheck {
    ursRequestId: string
    fileId: string
    requirement: string
}

export interface UrsRequestAiCheckResponse {
    note: string
    comment: string
}

export const verifyRequirementByAIClient = createAsyncThunk<UrsRequestAiCheckResponse, UrsRequestAiCheck
    , AppThunkAPIType>("document-dq-mappings/generateDqMappingsFromAI",
        async ({ ursRequestId, fileId, requirement }, { dispatch, rejectWithValue }) => {
            const result = await dispatch(postWithAuth({
                url: `api/UrsOffers/${ursRequestId}/ai/generate/`,
                payload: { ursRequestId, fileId, requirement },
            }))
            const { payload } = result
            if (postWithAuth.fulfilled.match(result)) {
                return payload as UrsRequestAiCheckResponse
            } else {
                return rejectWithValue(payload ?? { kind: 'unknown' })
            }
        })
